<template>
  <div class="wrongcard" :class="{'active': type > 0}" @click="towronglist">
  <div class="wb-l">
    <div class="wrongcard-title">错题本</div>
    <div class="wrongcard-count">
      <img class="emoj" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2025-02-11/5d0125785527994db7782e5990f56edc.png" mode="" />录入错题，打造你的专属提分库！
    </div>
  </div>
  <div class="wb-r">错题重练</div>
</div>
  <!-- <div class="wrongcard" @click="towronglist">
    <div class="wrongcard-title">
      错题本<img
        class="wb-icon"
        src="https://cdn-xcxcustom.weiyoubot.cn/20210625/47e9c2429e0b001533e774b242dc618e.png"
      />
    </div>
    <div class="wrongcard-count">全部错题：{{ total_wrong_count || 0 }}题</div>
  </div> -->
</template>
<script>
import { adClickReport, jumpWrongList } from "@/utils/common";
export default {
  props: ["total_wrong_count", "type", "name"],
  data() {
    return {};
  },
  methods: {
    towronglist() {
      localStorage.setItem('toWrong', 1)
      adClickReport(this.type, this.name);
      jumpWrongList(this)
    }
  }
};
</script>

<style lang="scss" scoped>
@function rem($px) {
  @return $px / 75 + rem;
}
.wrongcard {
  width: 100%;
  height: rem(123);
  background: linear-gradient(100deg, #FDFDFD 0%, #F5FAFE 30%, #E5F1FF 52%, #FCFAFB 73%, #FDF7F9 86%, #FDF7F9 100%);
  background-size: 100% 100%;
  /* margin-bottom: rem(40); */
  border-radius: rem(20) rem(20) 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: rem(20);
}

.wrongcard.active {
  border-radius: rem(20);
}

.wrongcard .wb-icon {
  width: rem(40);
  height: rem(40);
  margin-left: rem(10);
}

.wrongcard-title {
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: rem(30);
  margin-bottom: rem(10);
}

.wrongcard-count {
  font-size: rem(24);
  display: flex;
  align-items: center;
  color: #999999;
}

.emoj {
  width: rem(35);
  height: rem(35);
  margin-right: rem(4);
}

.wb-r {
  border: rem(2) solid #1890FF;
  width: rem(172);
  height: rem(52);
  border-radius: rem(60);
  font-size: rem(28);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/wrongCard.vue